import React, {useState} from 'react';
import { AdminNav } from './appBar';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { PAList } from './paList';
import { BigBoard } from './bigBoard';

export const Admin=()=>{
    const [selected,setSelected]=useState(0);

    const handleSelect=(event)=>{
        setSelected(event.selected);
    }
    
    return(
         <div>
            <AdminNav></AdminNav>
            <TabStrip
                selected={selected}
                onSelect={handleSelect}
            >
                <TabStripTab title="Program Status">
                    <div>
                        <BigBoard></BigBoard>
                    </div>
                </TabStripTab>

                <TabStripTab title="Adventure Areas">
                    <div>
                        <PAList></PAList>
                    </div>
                </TabStripTab>

            </TabStrip>
        </div>
    )

}